import { Grid } from "@mui/material"
import { useSelector } from "react-redux"

import { RootState } from "../../../store"
import {
	CampaignsPaginatedListState,
	CampaignsState,
} from "../../../store/actions/campaigns"
import NoData from "../../error/nodata"
import CampaignCard from "../card"

const CampaignsList = ({ bankId }: { bankId: string }) => {
	const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
	const campaignsState: CampaignsPaginatedListState = useSelector(
		(state: RootState) => state.campaignsPaginated
	)

	return (
		<Grid container flexWrap={"wrap"} alignContent={"space-between"}>
			{campaignsState?.list?.page?.content.map(
				(currentCampaign: CampaignsState) => {
					return (
						<CampaignCard
							key={currentCampaign?.id}
							bankId={bankId}
							campaignInfo={currentCampaign}
							userTimeZone={userTimeZone}
						/>
					)
				}
			)}
			{campaignsState?.list?.page?.content?.length === 0 && <NoData />}
		</Grid>
	)
}

export default CampaignsList
